import React from 'react'
import useI18n from '../../i18n/useI18n'
import { LogoCellRenderer } from '../../components/table-cell-renderers'
import { ApplicationStatusEnum } from '../../utils/enums'

const StudentApplicationCard = ({ application, onDetail, onHistory, onLogoClick }) => {
    const { t } = useI18n()

    if (!application) return null

    const getStatusInfo = (status) => {
        const statusMap = {
            [ApplicationStatusEnum.DRAFT]: {
                label: t('APPLICATIONS_STATUS_DRAFT'),
                percentage: 10,
                color: '#6c757d'
            },
            [ApplicationStatusEnum.SUBMITTED]: {
                label: t('APPLICATIONS_STATUS_SUBMITTED'),
                percentage: 25,
                color: '#17a2b8'
            },
            [ApplicationStatusEnum.UNDER_REVIEW]: {
                label: t('APPLICATIONS_STATUS_UNDER_REVIEW'),
                percentage: 50,
                color: '#ffc107'
            },
            [ApplicationStatusEnum.ACCEPTED]: {
                label: t('APPLICATIONS_STATUS_ACCEPTED'),
                percentage: 100,
                color: '#28a745'
            },
            [ApplicationStatusEnum.REJECTED]: {
                label: t('APPLICATIONS_STATUS_REJECTED'),
                percentage: 100,
                color: '#dc3545'
            },
            [ApplicationStatusEnum.WAITLISTED]: {
                label: t('APPLICATIONS_STATUS_WAITLISTED'),
                percentage: 75,
                color: '#ffc107'
            },
            [ApplicationStatusEnum.CANCELLED]: {
                label: t('APPLICATIONS_STATUS_CANCELLED'),
                percentage: 0,
                color: '#6c757d'
            }
        }
        return statusMap[status?.toLowerCase()] || {
            label: status,
            percentage: 0,
            color: '#6c757d'
        }
    }

    const status = application.applicationStatus || application.status
    const statusInfo = getStatusInfo(status)

    const university = application.program?.university || application.university
    const universityName = university?.name || '-'
    const logoUrl = university?.logoUrl || university?.logoURL || university?.logo

    const formatDate = (dateString) => {
        if (!dateString) return '-'
        try {
            const date = new Date(dateString)
            return date.toLocaleDateString('tr-TR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            })
        } catch {
            return dateString
        }
    }

    return (
        <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="card">
                <div className="body">
                    <div className="d-flex align-items-center mb-3">
                        {logoUrl && (
                            <div style={{ marginRight: '10px' }}>
                                <LogoCellRenderer
                                    imageUrl={logoUrl}
                                    imageAlt={universityName}
                                    onClick={onLogoClick}
                                    style={{ width: '50px', height: '50px' }}
                                />
                            </div>
                        )}
                        <div>
                            <h5 className="m-b-0">{universityName}</h5>
                            <small className="text-muted">{application.program?.name || '-'}</small>
                        </div>
                    </div>

                    <div className="mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                            <span className="badge" style={{ backgroundColor: statusInfo.color, color: '#fff' }}>
                                {statusInfo.label}
                            </span>
                            <small className="text-muted">{formatDate(application.createdAt)}</small>
                        </div>
                        <div className="progress" style={{ height: '5px' }}>
                            <div
                                className="progress-bar"
                                role="progressbar"
                                aria-valuenow={statusInfo.percentage}
                                aria-valuemin="0"
                                aria-valuemax="100"
                                style={{
                                    width: `${statusInfo.percentage}%`,
                                    backgroundColor: statusInfo.color
                                }}
                            ></div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end">
                        <button
                            className="btn btn-sm btn-info btn-icon btn-round m-r-5"
                            onClick={() => onDetail(application)}
                            title={t('APPLICATIONS_ACTIONS_VIEW_DETAIL')}
                        >
                            <i className="zmdi zmdi-eye"></i>
                        </button>
                        <button
                            className="btn btn-sm btn-outline-secondary btn-icon btn-round"
                            onClick={() => onHistory(application)}
                            title={t('APPLICATIONS_STATUS_HISTORY_BUTTON')}
                        >
                            <i className="zmdi zmdi-rotate-left"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StudentApplicationCard
